import { render, staticRenderFns } from "./CmsCommercialistTable.vue?vue&type=template&id=3551c022&scoped=true"
import script from "./CmsCommercialistTable.vue?vue&type=script&lang=ts"
export * from "./CmsCommercialistTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsCommercialistTable.vue?vue&type=style&index=0&id=3551c022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3551c022",
  null
  
)

export default component.exports